"use client";

import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/store";
import { ListingModalPlanOptions } from "./listingModalPlanOptions/ListingModalPlanOptions";
import { ListingModalSwapOneTime } from "./listingModalSwapOneTime/ListingModalSwapOneTime";
import { ListingType } from "../../../../enums/listing/TitleTypes";
import { ListingModalWrapper } from "./ListingModalWrapper";
import { useListingModalContext } from "./ListingModalProvider";
import { ListingModalLoading } from "./listingModalLoadingComponents/ListingModalLoading";
import { useListingModalLoading } from "../../../../hooks/trainingPlan/useListingModalLoading";
import { ListingModalPlanOptionsProvider } from "./listingModalPlanOptions";
import { useStripePrices } from "../../../../hooks/global/useStripePrices";
import { ListingModalSwapOneTimeProvider } from "./listingModalSwapOneTime";
import { FirebaseProvider } from "../../../firebase";
import {
  ListingModalQrCodeTitle,
  ListingModalQrCodeWrapper,
} from "./listingModalQrCode";
import { ListingModalQrCodeImg } from "./listingModalQrCode/ListingModalQrCodeImg";
import { ListingOneTimeHidden } from "./listingOneTimeHidden";
import { ListingModalMobileStores } from "./listingModalMobileStores";
import { ListingModalLogIn } from "./listingModalLogin/ListingModalLogIn";

export const ListingModal = () => {
  const listingRedux = useSelector((state: RootState) => state.trainingPlan);
  const userRedux = useSelector((state: RootState) => state.user.value);
  const prices = useSelector((state: RootState) => state.stripePrices?.value);
  const { state } = useListingModalContext();
  const userIsLogged = userRedux.loggedUser;
  const userHasSubscription = !!userRedux?.subscription;
  const userHasOne2One =
    userHasSubscription &&
    userRedux.subscription.subscriptionPlan.title === "one2one";
  const listingIsWorkout = listingRedux?.listingType === ListingType.WORKOUT;
  const listingIsStandalone =
    listingIsWorkout && !listingRedux.listingData.trainingPlan;
  const currentCoach = listingRedux.listingData.user;
  const isLoading = state.isLoading || !prices;
  const showQrCode = userIsLogged && listingIsWorkout && !listingIsStandalone;
  const showAllOptions =
    userIsLogged &&
    (!userHasSubscription || userHasOne2One) &&
    !listingIsWorkout;
  const showSwapOneTime =
    userIsLogged && userHasSubscription && !userHasOne2One && !listingIsWorkout;
  const showStandalone =
    userIsLogged && listingIsWorkout && listingIsStandalone;
  const listingIsFeatured = !listingRedux.listingData.hidden;

  useListingModalLoading();
  useStripePrices(currentCoach.goldValue);

  if (isLoading) {
    return <ListingModalLoading />;
  }

  if (!userIsLogged) {
    return (
      <ListingModalWrapper>
        <ListingModalLogIn />
      </ListingModalWrapper>
    );
  }

  if (showAllOptions && listingIsFeatured) {
    return (
      <ListingModalPlanOptionsProvider>
        <ListingModalWrapper>
          <ListingModalPlanOptions />
        </ListingModalWrapper>
      </ListingModalPlanOptionsProvider>
    );
  }

  if (showSwapOneTime && listingIsFeatured) {
    return (
      <ListingModalPlanOptionsProvider>
        <ListingModalSwapOneTimeProvider>
          <ListingModalWrapper>
            <ListingModalSwapOneTime />
          </ListingModalWrapper>
        </ListingModalSwapOneTimeProvider>
      </ListingModalPlanOptionsProvider>
    );
  }

  if ((showAllOptions || showSwapOneTime) && !listingIsFeatured) {
    return (
      <ListingModalPlanOptionsProvider>
        <ListingModalSwapOneTimeProvider>
          <ListingModalWrapper>
            <ListingOneTimeHidden />
          </ListingModalWrapper>
        </ListingModalSwapOneTimeProvider>
      </ListingModalPlanOptionsProvider>
    );
  }

  if (showStandalone || showQrCode) {
    return (
      <FirebaseProvider>
        <ListingModalQrCodeWrapper>
          <ListingModalQrCodeImg />
          <ListingModalQrCodeTitle className={"mt-4"} />
        </ListingModalQrCodeWrapper>
        <ListingModalMobileStores />
      </FirebaseProvider>
    );
  }
};
